import React from 'react';
import { NavBarLinks } from './NavBarLinks';

/**
 * @file BottomNavBar.tsx
 * @brief Navigationsleiste am unteren Bildschirmrand der Anwendung.
 *
 * Diese Komponente stellt eine Navigationsleiste mit Links zu verschiedenen Bereichen der Anwendung bereit.
 * Einige Links sind nur für Benutzer mit der Rolle 'admin' sichtbar.
 *
 * @returns {JSX.Element} Ein React-Element, das die untere Navigationsleiste darstellt.
 */
const BottomNavBar = () => {
  return (
    <nav className="bottom-nav-bar">
      <NavBarLinks isBottomNav={true} />
    </nav>
  );
};

export default BottomNavBar;
